define('GameDayCore/GDModel/ValueObjects/Gamecenter/TeamLineupHittingStats',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(TeamLineupHittingStats);

	function TeamLineupHittingStats($data) {
		var vo = VO.ensureVO(this, TeamLineupHittingStats),
			data = $data;

			vo.players = [];
			data.mlb_individual_hitting_season_total_repeater.mlb_individual_hitting_season_total.forEach(function(player) {
				vo.players[player.player_id] = player.queryResults.row;
			});
	}

	return TeamLineupHittingStats;
});
